<template>
  <b-modal
    v-model="show"
    size="lg"
    :modal-class="isLoading || isTimeOffDeleteLoading ? 'log-times-modal loading' : 'log-times-modal'"
    header-class="log-times-modal-header-custom"
    hide-footer
    centered
    @hide="closeModal"
  >
    <template #modal-header="{ close }">
      <ModalHeader :title="title" :onCloseButton="close" />
    </template>
    <div class="log-times-modal-body">
      <div v-if="error" class="alert alert-danger">
        {{ error }}
      </div>

      <template v-else-if="!isLoading">
        <div class="table_theme-info p-0">
          <slot></slot>

          <template v-if="logTimes.length">
            <table v-if="hasTimeOff" class="table-modal table mb-2">
              <thead>
              <tr>
                <th scope="col">
                  Icon
                </th>
                <th scope="col">Status</th>
                <th scope="col">Summary</th>
                <th scope="col">Time</th>
                <th scope="col" class="comment-column">Comment</th>
                <th scope="col" class="actions-column">Actions</th>
              </tr>
              </thead>
              <tbody v-for="(logTime, index) in logTimes" :key="index">
              <tr v-if="logTime.time_off" :data-time-off-id="logTime.time_off.id">
                <td>
                  <TimeOffIcon :name="logTime.time_off.time_offs_settings.icon" :color="logTime.time_off.time_offs_settings.color" className="time-off-icon" />
                </td>
                <td>
                  <StatusBadge :data="{
                    label: logTime.time_off.status.charAt(0).toUpperCase() + logTime.time_off.status.slice(1),
                    class: logTime.time_off.status
                  }" />
                </td>
                <td>
                  {{ logTime.time_off.time_offs_settings.name }}
                </td>
                <td class="time">
                  {{ logTime.time_off.date_from }} -
                  {{ logTime.time_off.date_to }}
                </td>
                <td class="comment-column">
                <span
                  :class="{'no-comment': !logTime.time_off.comment}"
                  v-html="
                    logTime.time_off.comment
                      ? nlToBr(logTime.time_off.comment)
                      : 'No comments'"></span>
                </td>
                <td class="actions-column">
                  <TimeOffLinks
                    :item="logTime.time_off"
                    :key="index"
                    :onDelete="handleTimeOffDelete"
                    @updatedTimeOff="savedTimeOff($event.data, index)"
                    @deletedTimeOff="deletedLogTime(index)"
                    @timeOffApproved="timeOffApproved"
                  />
                </td>
              </tr>
              </tbody>
            </table>
            <!-- it was talled that we should not show any logTime.time_off.messages here (not removed in case if we still need it) -->
            <!-- <template v-for="(logTime, index) in logTimes">
              <div
                v-if="logTime && logTime.time_off && logTime.time_off.messages && logTime.time_off.messages.length"
                :key="'msg-' + index"
              >
                <div class="mt-2 mb-2">
                  <div v-for="({ type, text }, messageIndex) in logTime.time_off.messages" :key="messageIndex">
                    <div class="mb-1 alert time-off-msg">
                      {{ text }}
                    </div>
                  </div>
                </div>
              </div>
            </template> -->
            <table v-if="hasTasksWithoutTimeOff" class="table-modal table mt-2 mb-0">
              <thead>
              <tr>
                <th scope="col" class="task-column">
                  Task
                </th>
                <th scope="col">Summary</th>
                <th scope="col" class="time-column">Time</th>
                <th scope="col" class="comment-column">Comment</th>
                <th scope="col" class="actions-column">Actions</th>
              </tr>
              </thead>
              <tbody>
              <template v-for="(logTime, index) in logTimes">
                <tr v-if="!logTime.time_off" :key="index" :data-log-time-id="logTime.id">
                  <td class="task-column">
                    <a
                      target="_blank"
                      v-if="logTime.external_link"
                      :href="logTime.external_link"
                    >
                      {{ logTime.task.key }}
                    </a>
                    <span v-else>{{ logTime.task.key }}</span>
                  </td>
                  <td>
                    <a
                      target="_blank"
                      v-if="logTime.external_link"
                      :href="logTime.external_link"
                    >{{ logTime.task.name }}
                    </a>
                    <span v-else>{{ logTime.task.name }}</span>
                  </td>
                  <td class="time-column">
                    <a
                      class="time"
                      target="_blank"
                      v-if="logTime.external_link"
                      :href="logTime.external_link"
                    >
                      {{ logTime.time_formatted }}</a>
                    <span class="time" v-else>{{ logTime.time_formatted }}</span>
                  </td>
                  <td class="comment-column">
                  <span
                    :class="{'no-comment': !logTime.comment}"
                    v-html="
                      logTime.comment ? nlToBr(logTime.comment) : 'No comments'
                    "
                  />
                  </td>
                  <td class="actions-column">
                    <LogTimesLinks
                      :item="logTime"
                      :key="index"
                      @updatedLogTime="savedLogTime($event.data, index)"
                      @deletedLogTime="deletedLogTime(index)"
                    />
                  </td>
                </tr>
              </template>
              </tbody>
            </table>
          </template>
          <div v-else class="no-items"> No log times </div>
        </div>
        <div v-if="isAvailableAdd" class="mt-2 d-flex gap-16 justify-content-end">
          <LogTimeAdd
            :loggedAt="loggedAt"
            :user="user"
            @createdLogTime="savedLogTime($event.data)"
          />
          <TimeOffAdd
            :date="loggedAt"
            :user="user"
            @createdTimeOff="createdTimeOff($event.data)"
          />
        </div>
      </template>
    </div>
  </b-modal>
</template>

<script>
import Moment from 'moment/moment'
import ModalHeader from '@components/modals/ModalHeader.vue'
import LogTimesLinks from '../LogTimesLinks.vue'
import TimeOffLinks from '../TimeOffLinks.vue'
import LogTimeAdd from '../LogTimeAdd.vue'
import TimeOffAdd from '../TimeOffAdd.vue'
import TimeOffIcon from '@components/TimeOffIcon.vue'
import StatusBadge from '@components/StatusBadge.vue'

export default {
  name: 'LogTimesModal',
  components: {
    ModalHeader,
    LogTimesLinks,
    TimeOffLinks,
    LogTimeAdd,
    TimeOffAdd,
    TimeOffIcon,
    StatusBadge
  },
  props: {
    isLoading: {
      type: Boolean,
      default: false
    },
    error: String,
    modalId: String,
    title: String,
    user: {
      type: Object,
      default () {
        return {}
      }
    },
    loggedAt: {
      type: String,
      default: ''
    },
    content: String,
    logTimes: {
      type: Array,
      default () {
        return []
      }
    },
    value: Boolean
  },
  data () {
    return {
      logTimesChanged: false,
      isValidated: false,
      isTimeOffDeleteLoading: false
    }
  },
  computed: {
    hasTasksWithoutTimeOff () {
      return this.logTimes.some(logTime => !logTime.time_off)
    },
    show: {
      get () {
        return this.value && this.isValidated
      },
      set (val) {
        this.$emit('input', val)
      }
    },
    hasTimeOff () {
      return this.logTimes.some(logTime => logTime.time_off)
    },
    isAvailableAdd () {
      return !this.user || this.getUser.id === this.user.id
    }
  },
  async mounted () {
    this.logTimesChanged = false
    await this.validateTimeOffs()
    this.isValidated = true
  },
  methods: {
    savedLogTime (logTime, index = null) {
      if (index === null) {
        index = this.logTimes.length
      }
      this.$set(this.logTimes, index, logTime)
      this.logTimesChanged = true
    },
    createdTimeOff (timeOff, index = null) {
      const logTime = timeOff.log_times.find(logTime => Moment(logTime.logged_at).format('YYYY-MM-DD') === this.loggedAt)
      if (logTime) {
        logTime.time_off = timeOff
        this.savedLogTime(logTime, index)
      }
      this.logTimesChanged = true
    },
    savedTimeOff (timeOff, index = null) {
      let logTime = this.findLogTimeByTimeOff(timeOff.id)

      const isCurrentDateIncluded = timeOff.date_from <= this.loggedAt && timeOff.date_to >= this.loggedAt
      if (!logTime || !isCurrentDateIncluded) {
        this.deletedLogTime(index)
        this.logTimesChanged = true
      } else {
        logTime.time_off = timeOff
        this.savedLogTime(logTime, index)
        this.validateTimeOffs()
      }
    },
    deletedLogTime (logTimeId) {
      this.$delete(this.logTimes, logTimeId)
      this.logTimesChanged = true
      this.validateTimeOffs()
    },
    timeOffApproved () {
      this.logTimesChanged = true
    },
    findLogTimeByTimeOff (timeOffId) {
      return this.logTimes.find(logTime => logTime.time_off && logTime.time_off.id === timeOffId)
    },
    closeModal () {
      if (this.logTimesChanged) {
        this.$emit('logTimesChanged')
      }
    },
    async validateTimeOffs () {
      for (const i in this.logTimes) {
        const logTime = this.logTimes[i]
        if (logTime.time_off) {
          const timeOffFields = {
            comment: logTime.time_off.comment,
            date_from: logTime.time_off.date_from,
            date_to: logTime.time_off.date_to,
            id: logTime.time_off.id,
            time_offs_settings_id: logTime.time_off.time_offs_settings_id,
            user_id: logTime.time_off.user_id
          }
          await this.$api.timeOffs.validateTimeOff(timeOffFields)
            .then(() => {
              logTime.time_off.messages = []
            })
            .catch(error => {
              logTime.time_off.messages = []

              if (error.response.data.errors) {
                const errors = Object.values(error.response.data.errors)
                for (var i = 0; i < errors.length; i++) {
                  const errorText = Array.isArray(errors[i]) ? errors[i][0] : errors[i]
                  logTime.time_off.messages.push({ type: 'danger', text: errorText })
                }
              }

              if (error.response.data.warnings) {
                const warnings = Object.values(error.response.data.warnings)
                logTime.time_off.messages = []
                for (var j = 0; j < warnings.length; j++) {
                  const warningText = Array.isArray(warnings[j]) ? warnings[j][0] : warnings[j]
                  logTime.time_off.messages.push({ type: 'warning', text: warningText })
                }
              }
            })
            .finally(() => {
              this.$forceUpdate()
            })
        }
      }
    },
    nlToBr: function (text) {
      const ret = text.replace(/(?:\r\n|\r|\n)/g, '<br>')
      return ret
    },
    setTimeOffDeleteLoading (loading) {
      this.isTimeOffDeleteLoading = loading
    },
    handleTimeOffDelete () {
      return {
        setLoading: (loading) => this.setTimeOffDeleteLoading(loading)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
::v-deep .log-times-modal {
  .modal-dialog {
    width: 792px;
  }
}

.loader-container {
  position: relative;
}

.log-times-modal-body {
  position: relative;
  min-height: 60px;
}

.no-items {
  padding: 18px 0;
}

.table_theme-info {
  background: none;
}

::v-deep .log-times-modal-header-custom {
  padding-top: 15px;
}

.table-modal {
  border-collapse: separate;
  border-radius: 5px;
  background-color: #f3f5f7;

  th, td {
    padding-left: 8px;
    padding-right: 8px;
    padding-bottom: 3px;
  }

  th {
    padding-top: 8px;
  }

  td {
    padding-top: 4px;
  }

  tr:last-child {
    td {
      padding-bottom: 8px;
    }
  }

  th:first-child, td:first-child {
    padding-left: 16px;
    width: 90px;
  }

  th:last-child, td:last-child {
    padding-right: 16px;
  }

  tbody {
    .no-comment {
      opacity: 0.5;
    }

    .time {
      color: $fontColorBase;
    }
  }
}

.actions-column {
  width: 90px;
  text-align: initial;
}

.task-column, .time-column {
  white-space: nowrap;
}

.comment-column {
  min-width: 160px;
  max-width: 300px;
  overflow: auto;
}

.time-off-msg {
  color: $fontColorBase;
  background-color: $tableTrHoverColor;
  padding: 3px 10px;
  border-radius: 5px;
  width: fit-content;
}

</style>
